import { Component, Input, OnInit } from '@angular/core';

interface DecisioningQualifierOverride {
  decisioningQualifierField: string;
}

@Component({
  selector: 'activity-row-decisioning-qualifier-override',
  template: `
    <div style="float: left; margin-right: 10px;">
        <mat-icon>gavel</mat-icon>
    </div>
    <div>
      <div class="description tw-pt-1">
        <span ng-bind-html="activity.activityHtml"></span>
        <strong class="tw-text-sm">Decisioning Qualifier Override by Lender</strong>
        <div class="text tw-pt-1 tw-px-9">
          {{ activity.meta['loanProductLenderName'] }} ran decisioning with overrides for: {{ activity.meta['loanProductName'] }}
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-px-9 tw-pt-3">
          <div class="tw-pr-5">
            <strong>Override(s):</strong>
            <div class="tw-w-full tw-pt-1">
            <mat-chip-listbox class="is-list tw-flex">
              <div class="tw-grid tw-grid-cols-1 tw-gap-2">
                <div>
                  <mat-chip-option
                    *ngFor="let override of formattedOverrides"
                    class="tw-text-xs"
                  >{{ override }}</mat-chip-option>
                </div>
              </div>
            </mat-chip-listbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})

export class ActivityRowDecisioningQualifierOverrideComponent implements OnInit {

  @Input() activity;
  overrides: DecisioningQualifierOverride[] = [];
  formattedOverrides: string[] = [];
  fieldMapping = {
    annualRevenue: 'Annual Revenue',
    balanceAvg3Month: 'Balance Avg 3 Month'
  };

  /**
   * Angular lifecycle
   * @return void
   */
  ngOnInit(): void {
    this.overrides = this.activity.meta['decisioningQualifierOverrides'];
    this.overrides?.map((item: any) => {
      const field = item.decisioningQualifierField;
      if (field in this.fieldMapping) {
        const label: string = this.fieldMapping[field];
        this.formattedOverrides.push(label);
      }
    });
  }
}
